import { Box } from "@mantine/core";
import EpPopover from "../Components/EpPopover";
import { TdText } from "../Components/EpTable";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
const fromNow = (timestamp: number) => {
  const time = new Date().getTime() - timestamp;

  // 小于1min展示 <1 min
  // 大于等于1min且小于2min展示 1 min
  // 大于等于2min且小于3min展示 2 mins
  // 大于1h后直接展示Tx发生时间：03:45（UTC时间）；

  const second = Math.floor(time / 1000);
  const min = Math.floor(second / 60);
  const hour = Math.floor(min / 60);

  let text = "";
  if (second < 12) text = `Just Now`;
  if (second >= 12 && second < 60) text = `secs`;
  if (min > 0 && min < 60) text = `${min} min${min === 1 ? "" : "s"}`;
  if (hour > 0) text = dayjs.utc(timestamp).format("HH:mm");

  return text;
};

export const EpTime = ({
  dark,
  timestamp,
}: {
  dark: boolean;
  timestamp: number;
}) => {
  return (
    <EpPopover
      position="right"
      target={
        <Box>
          <TdText
            sx={{
              whiteSpace: "nowrap",
              color: dark ? "#B5B5C3" : "#B5B5C3",
            }}
            size="xs"
          >
            {fromNow((timestamp ?? 0) * 1000)}
          </TdText>
        </Box>
      }
      withArrow
    >
      <TdText
        size="sm"
        sx={(theme) => ({
          color:
            theme.colorScheme === "dark" ? theme.white : theme.colors.dark[6],
        })}
      >
        {dayjs.utc((timestamp ?? 0) * 1000).format("MMM D, YYYY HH:mm:ss")}
        (UTC)
      </TdText>
    </EpPopover>
  );
};
